<template lang="pug">
v-list-item
    template(v-slot:prepend)
        MilSymbol(:value='value' :size='iconSize' outlineColor='#1f1f1f')
    v-label
        slot
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import MilSymbol from './MilSymbol.vue';

export default defineComponent({
    name: 'LabelledMilSymbol',
    components: {
        MilSymbol,
    },
    props: {
        value: {
            // This is the SIDC code
            type: String,
            default: undefined,
        },
        xLarge: Boolean,
        large: Boolean,
        small: Boolean,
        xSmall: Boolean,
    },
    computed: {
        iconSize: function (): number {
            if (this.xLarge) return 80;
            if (this.large) return 70;
            if (this.small) return 50;
            if (this.xSmall) return 40;
            return 60;
        },
    },
});
</script>
